import React from "react";
import jamin from "../assets/jamin.jpeg";
import tabby from "../assets/kanyi.jpg";
import ericko from "../assets/ericko.jpg";

const Testimonials = () => {
  return (
    <div>
      <div class="min-w-screen min-h-screen  flex items-center justify-center">
        <div class="w-full  border-t border-b border-gray-200 px-5">
          <div class="w-full max-w-6xl mx-auto">
            <div class="text-center max-w-xl mx-auto">
              <h1 class="text-3xl md:text-4xl font-bold mb-5  text-teal-600">
                What people <br />
                are saying about me.
              </h1>
              <h3 class="text-xl mb-5 dark:text-white font-light">
                Watching a professional practice is craft is amazing and here
                are some reviews about me.
              </h3>
              <div class="text-center mb-10">
                <span class="inline-block w-1 h-1 rounded-full bg-teal-600 ml-1"></span>
                <span class="inline-block w-3 h-1 rounded-full bg-teal-600 ml-1"></span>
                <span class="inline-block w-40 h-1 rounded-full bg-teal-600"></span>
                <span class="inline-block w-3 h-1 rounded-full bg-teal-600 ml-1"></span>
                <span class="inline-block w-1 h-1 rounded-full bg-teal-600 ml-1"></span>
              </div>
            </div>
            <div class="-mx-3 md:flex items-start">
              <div class="px-3 md:w-1/3">
                <div class="w-full mx-auto rounded-lg bg-white border border-gray-200 p-5 text-gray-800 font-light mb-6">
                  <div class="w-full flex mb-4 items-center">
                    <div class="overflow-hidden rounded-full w-10 h-10 bg-gray-50 border border-gray-200">
                      <img src={jamin} alt="Jamin Walekhwa" />
                    </div>
                    <div class="flex-grow pl-3">
                      <h6 class="font-bold text-sm uppercase text-gray-600">
                        Jamin Walekhwa.
                      </h6>
                    </div>
                  </div>
                  <div class="w-full">
                    <p class="text-sm leading-tight">
                      <span class="text-lg leading-none italic font-bold text-gray-400 mr-1">
                        "
                      </span>
                      I am pleased to highly recommend Mr. Simon Wachira for his
                      exceptional work as a software engineer. His expertise and
                      meticulous attention to detail were instrumental in
                      developing our business website, "Big Farmer". Mr.
                      Wachira's ability to translate complex requirements into
                      efficient software applications, coupled with his
                      professionalism and commitment to excellence, make him an
                      invaluable asset to any project.
                      <span class="text-lg leading-none italic font-bold text-gray-400 ml-1">
                        "
                      </span>
                    </p>
                  </div>
                </div>
              </div>
              <div class="px-3 md:w-1/3">
                <div class="w-full mx-auto rounded-lg bg-white border border-gray-200 p-5 text-gray-800 font-light mb-6">
                  <div class="w-full flex mb-4 items-center">
                    <div class="overflow-hidden rounded-full w-10 h-10 bg-gray-50 border border-gray-200">
                      <img src={tabby} alt="Tabitha Kanyi"/>
                    </div>
                    <div class="flex-grow pl-3">
                      <h6 class="font-bold text-sm uppercase text-gray-600">
                        Tabitha Kanyi.
                      </h6>
                    </div>
                  </div>
                  <div class="w-full">
                    <p class="text-sm leading-tight">
                      <span class="text-lg leading-none italic font-bold text-gray-400 mr-1">
                        "
                      </span>
                      Simon is efficient, fast, creative and proffessional. He
                      is a detail oriented team player, who always ensures the
                      company goals are achieved on a timely manner.
                      <span class="text-lg leading-none italic font-bold text-gray-400 ml-1">
                        "
                      </span>
                    </p>
                  </div>
                </div>
              </div>
              <div class="px-3 md:w-1/3">
                <div class="w-full mx-auto rounded-lg bg-white border border-gray-200 p-5 text-gray-800 font-light mb-6">
                  <div class="w-full flex mb-4 items-center">
                    <div class="overflow-hidden rounded-full w-10 h-10 bg-gray-50 border border-gray-200">
                      <img src={ericko} alt="Erick Kiplagat" />
                    </div>
                    <div class="flex-grow pl-3">
                      <h6 class="font-bold text-sm uppercase text-gray-600">
                        Eric Kiplagat.
                      </h6>
                    </div>
                  </div>
                  <div class="w-full">
                    <p class="text-sm leading-tight">
                      <span class="text-lg leading-none italic font-bold text-gray-400 mr-1">
                        "
                      </span>
                      I engaged Wachira to help customise and maintain an ERP system for a client. The system was needed on short notice and Wachira dedicated 2 days of his time to work on the project. The client was satisfied and I am looking forward to engage him in other projects.
                      <span class="text-lg leading-none italic font-bold text-gray-400 ml-1">
                        "
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Testimonials;
